import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Endereco } from '../models/endereco.model';
import { Combobox } from 'pmv-common';

@Injectable()
export class EnderecoService {

  constructor(private httpClient: HttpClient) { }

  GetByParam(id: number): Observable<Endereco> {
    return this.httpClient.get<Endereco>(`/Endereco/GetByParam/${id}`).pipe();
  }
  
  GetEstadoCombobox(): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Endereco/GetEstado/Combobox`);
  }

  GetCidadesByUfCombobox(uf: string): Observable<Combobox[]> {
    return this.httpClient.get<Combobox[]>(`/Endereco/GetCidades/Combobox/${uf}`);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/endereco.service.ts